<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>用户地址查询</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-input
          placeholder="请输入用户ID"
          clearable
          v-model="userId"
          size="mini"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-input
          placeholder="请输入地址"
          clearable
          v-model="coinWallet"
          size="mini"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button type="primary" @click="handleSearch" size="mini"
          >搜索</el-button
        >
      </div>
      <user-list @refresh="refreshList"></user-list>
    </el-card>
    <!-- 添加用户信息弹框 -->
  </div>
</template>

<script>
import "./store";
import UserList from "./components/list";
import { mapState, mapActions, mapMutations } from "vuex";
import { QUERY_TYPE, PAGINATION } from "./constants";
import moment from "moment";
export default {
  name: "UserAddress",
  components: {
    UserList,
  },
  data() {
    return {
      userId: "",
      coinWallet: "",
    };
  },
  computed: {
    ...mapState("userAddress", ["pagination"]),
  },
  methods: {
    ...mapActions("userAddress", ["list"]),
    refreshList(data = {}) {
      this.list({
        userId: this.userId,
        coinWallet: this.coinWallet,

        ...this.pagination,
        ...data,
      });
    },

    handleSearch() {
      this.list({
        userId: this.userId,
        coinWallet: this.coinWallet,

        ...PAGINATION,
      });
    },
  },
  created() {
    this.list({
      userId: this.userId,
      coinWallet: this.coinWallet,
      ...PAGINATION,
    });
  },
};
</script>

<style lang="less" scoped></style>
